import api from "@services/api";

export const getAllPublicLevel1Resources = async () => {
  const { data } = await api.get("/level1Resources");

  return data.level1Resources;
};
